import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

export function AppIconHome({ size = 20, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_TEXT_PRIMARY

  return (
    <Svg width={size} height={size} viewBox="0 0 16.1 16.0995" fill="none">
      <Path
        fill={fill}
        d="M8.05052 0C8.93764 7.38702e-05 9.71334 0.28452 10.5199 0.746953C11.3019 1.19532 12.1871 1.85728 13.2782 2.66992C13.865 3.10701 14.3513 3.46784 14.7263 3.7971C15.1121 4.13578 15.4343 4.48602 15.6686 4.92636C16.1253 5.78462 16.0997 6.75143 16.0997 8.01494V9.07252C16.0997 10.4715 16.1026 11.634 15.9585 12.5517C15.8072 13.5139 15.4767 14.3384 14.7263 14.9806C13.9973 15.6044 13.0974 15.8616 12.0502 15.9821C11.0172 16.1009 9.69826 16.0995 8.05052 16.0995C6.4024 16.0995 5.08287 16.1009 4.0498 15.9821C3.00276 15.8616 2.10363 15.6043 1.37469 14.9806C0.624413 14.3384 0.293817 13.5139 0.14258 12.5517C-0.0015939 11.634 0.000253486 10.4715 0.00025355 9.07252V8.01494C0.00024905 6.75161 -0.0250646 5.78453 0.431388 4.92636C0.665691 4.48603 0.987958 4.13575 1.37365 3.7971C1.74869 3.46783 2.23499 3.10701 2.82185 2.66992C3.91277 1.85738 4.79818 1.19536 5.58007 0.746953C6.38675 0.284408 7.16331 0.000109237 8.05052 0ZM5.9229 10.2838C5.39436 10.2841 4.96505 10.7131 4.96505 11.2417C4.96505 11.7703 5.39436 12.1993 5.9229 12.1995H10.1781C10.7069 12.1995 11.136 11.7705 11.136 11.2417C11.136 10.7129 10.7069 10.2838 10.1781 10.2838H5.9229Z"
      />
    </Svg>
  )
}
